import { LoadsClientAttributes } from "@/types/clientAttributes";
import { LoadsMatchingAttributes } from "@/types/matchingAttribute";
import { Client, Coach } from "@/types/page";

export function hasNeurodivergentMatch(
    client: Client & LoadsClientAttributes,
    coach: Coach & LoadsMatchingAttributes,
) {
    return (
        client.attributes?.wants_coach_with_neurodiverse_experience &&
        coach.matching_attributes?.some(
            (attribute) => attribute.code_name === "neurodivergent_expertise",
        )
    );
}
